import dayjs from 'dayjs';
// Ejemplo: usar dayjs para mostrar fecha/hora actual formateada
// Si existe un elemento #now en la página, lo actualizamos; si no, lo mostramos en consola.
export const initHome = () => {
  console.log('[home] init');

  const now = dayjs();
  const formatted = now.format('YYYY-MM-DD HH:mm:ss');

  const nowEl = document.getElementById('now');
  if (nowEl) {
    nowEl.textContent = `Ahora mismo: ${formatted}`;
  } else {
    console.log(`[home] Fecha/hora actual (dayjs): ${formatted}`);
  }

  const btn = document.getElementById('home-btn') as HTMLButtonElement | null;
  btn?.addEventListener('click', () => alert(`Home funcionando — ${formatted}`));
};
